module.exports = __webpack_public_path__ + "static/img/th.76fca72f.svg";